import audio from '@/scripts/audio';
import eventHub from '@/scripts/eventHub';
import gsap from 'gsap';
import {
  AnimatedSprite,
  Loader,
  Point,
  Sprite,
} from 'pixi.js';
import state from '../state';
import vars from '../vars';
import Actor from './Actor';

class Coin extends Actor {
  constructor(parent, x, y, type = 'seed') {
    super(parent);
    this.x = x;
    this.y = y;
    this.type = type;

    this.catched = false;
    this.heavyLightTimer = -1;

    if (this.type === 'seed') {
      this.sprite = new Sprite(Loader.shared.resources['textures/SEED'].texture);
    }
    if (this.type === 'light') {
      this.sprite = new AnimatedSprite(
        Object.values(Loader.shared.resources['sprites/LIGHT'].spritesheet.textures),
      );
      this.sprite.animationSpeed = 0.3;
      this.sprite.loop = true;
      this.sprite.play();
    }
    if (this.type === 'heavy') {
      this.sprite = new AnimatedSprite(
        Object.values(Loader.shared.resources['sprites/HEAVY'].spritesheet.textures),
      );
      this.sprite.animationSpeed = 0.3;
      this.sprite.loop = true;
      this.sprite.play();
    }

    this.resize();
    this.parent.addChild(this.sprite);

    this.floatTimeline = gsap.timeline({ repeat: -1, yoyo: true })
      .to(this.sprite.position, { y: '+=10', ease: 'power2.inOut', duration: 1 });
  }

  resize() {
    this.sprite.anchor = new Point(0.5, 0.5);
    this.sprite.width = 35;
    this.sprite.height = 60;

    this.sprite.scale.set(0.5, 0.5);

    this.sprite.position.y = this.y;
    this.sprite.position.x = vars.layout.FRAME_WIDTH + (this.sprite.width / 2) + this.x;
  }

  catch() {
    this.catched = true;
    if (this.type !== 'seed') {
      audio.play('powerdown');
      clearTimeout(this.heavyLightTimer);
      this.heavyLightTimer = setTimeout(() => {
        state.light = false;
        state.heavy = false;
        eventHub.$emit('lightend');
        eventHub.$emit('heavyend');
      }, 5000);
    }
    switch (this.type) {
      case 'seed':
        state.coins += 1;
        audio.play('yummi');
        break;
      case 'light':
        state.heavy = false;
        eventHub.$emit('heavyend');
        state.light = true;
        eventHub.$emit('lightstart');
        break;
      case 'heavy':
        state.light = false;
        eventHub.$emit('lightend');
        state.heavy = true;
        eventHub.$emit('heavystart');
        break;
      default:
        break;
    }
    this.sprite.alpha = 0;
  }

  destroy() {
    this.sprite.destroy();
  }
}

export default Coin;
